import styled from 'styled-components';

const FlexContainer = styled.div`
  .flexContainer {
    display: flex;
    flex-wrap: wrap;
    width: 1215px;
    margin-top: 25px;
    min-height: 818px;
    padding: 25px 26px 18.3px 0px;
    border-radius: 4px;
    border: solid 1px #eaeaea;
    background-color: #ffffff;
    margin-left: 25px;
  }

  .parentGrid {
    min-height: 768px;
    margin: 0px 0px 0px 26px;
    display: grid;
    grid-template-columns: repeat(4,1fr);
    grid-auto-rows: 314px;
  }

  .flexContainer > .parentGrid > .childBox {
    width: 275px;
    height: 224px;
    margin: 25px 25px 45px 0px;
    padding: 1px 1px 17.7px;
    border-radius: 4px;
    border: solid 1px #eaeaea;
    background-color: #ffffff;
  }

  .upperBox {
    width: 273px;
    height: 176px;
    margin: 0 0 14px;
    border-radius: 3px;
    background-color: #eaeaea;
  }
  .upperBoxImage {
    width: 273px;
    height: 176px;
    margin: 0 0 14px;
    border-radius: 3px;
    background-color: #eaeaea;
    position: relative;
  }

  .myBoards {
    width: 100px;
    height: 22px;
    margin: 0 8px 10px 0;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    text-transform: capitalize;
  }

  .AddBoard {
    float: right;
    width: 116px;
    height: 32px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
  }

  .titleBar{
    margin-left: 28px;
    padding-right: 74px;
    width: inherit;
    max-height: 50 px;
    border: solid black:
  }

  .boardName{
    width: 37px;
    height: 15px;
    margin: 14px 30px 5px 23px;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
  }

  .lowerBox{
    padding-left: 0px;
    padding-right: 0px;
  }

  .action-btn{
    height: 20px;
    float: right;
    margin-right: 12px;
  }

  .description {
    width: 66px;
    height: 15px;
    margin: 5.3px 140px 0 22.7px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #6e6e6e;
  }

  .items {
    width: 40px;
    height: 15px;
    margin: 4px 0px 0.3px -1px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
  }

  .menuText {
      width: 47px;
      height: 17px;
      margin: 0 0 0 12px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
  }

  .noResults{
    margin: auto;
    width: 1226px
  }

  .bookmark{
    width: 40px;
    height: 15px;
    margin: 0.8px 3px 0 17.1px;
  }
  
`;

const Avatar = styled.div`
  font-size: 14px;
  height: 24.7px;
  width: 25.6px;
  background-color: #0c131f;
  color: white;
  border-radius: 20%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 13.6px;
  right: 13.5px;
`;
export { FlexContainer, Avatar };
